<template>
<div class="fieldValidationClass">

</div>
      
</template>

<script>
import { getCrossFieldData } from '@/data-model';
// import { isEmpty, cloneDeep } from 'lodash';

export default {
    components: { },
    props: {

    },
    data () {
        return {
        };
    },
    created () {
    },
    methods: {
        async validateNumberRule (fieldsList, formData, tempFormData) {
            // console.log(tempFormData);
            if (fieldsList && fieldsList.length > 0) {
                let isRefuse = false;
                let resObj = {isRefuse: false, refuseInfo: ''};
                let fieldsMap = new Map();
                let fieldsValueMap = new Map();
                if (fieldsList && Array.isArray(fieldsList)) {
                    for (var index = 0; index < fieldsList.length; index++) {
                        let field = fieldsList[index];
                        fieldsMap.set(field.id, field);
                        fieldsValueMap.set(field.id,formData[field.id]);
                    }
                }
                for (var fieldIndex = 0; fieldIndex < fieldsList.length; fieldIndex++) {
                    let field = fieldsList[fieldIndex];
                    if (field.type === 'number' && field.options.formulaExp && formData[field.formField]) {
                        if (field.isRead) {
                            continue;
                        }
                        if (field.isView) {
                            isRefuse = await this.numberValidate(field, formData, fieldsMap, tempFormData,fieldsValueMap);
                            if (isRefuse) { // 不通过数字类型校验
                                resObj.isRefuse = isRefuse;
                                resObj.tempRefName = 'fieldItemChild' + fieldIndex;
                                resObj.tempRefKey = field.id;
                                resObj.refuseInfo = '：字段【' + field.name + '】的校验规则不通过，查看字段后面的小问号说明';
                                break;
                            }
                        }
                    }
                }
                return resObj;
            }
        },
        async numberValidate (field, formData, fieldsMap, tempFormData,fieldsValueMap) {
            let isRefuse = false;
            let formulaExp = field.options.formulaExp;
            let ifPass = await this.chkPassRule(field, formulaExp, formData, fieldsMap, tempFormData,fieldsValueMap);
            if (formulaExp && !ifPass) {
                isRefuse = true;
            }
            return isRefuse;
        },
        async chkPassRule (field, formulaExp, formData, fieldsMap, tempFormData,fieldsValueMap) {
            let arr = [];
            if (formulaExp.indexOf('>=') !== -1) {
                arr = formulaExp.split('>=');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] >= arr[1]) {
                    return true;
                }
            } else if (formulaExp.indexOf('<=') !== -1) {
                arr = formulaExp.split('<=');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] <= arr[1]) {
                    return true;
                }
            } else if (formulaExp.indexOf('>') !== -1) {
                arr = formulaExp.split('>');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] > arr[1]) {
                    return true;
                }
            } else if (formulaExp.indexOf('<') !== -1) {
                arr = formulaExp.split('<');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] < arr[1]) {
                    return true;
                }
            } else if (formulaExp.indexOf('!=') !== -1) {
                arr = formulaExp.split('!=');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] !== arr[1]) {
                    return true;
                }
            } else if (formulaExp.indexOf('=') !== -1) {
                arr = formulaExp.split('=');
                arr = await this.dealArr(field, arr, formData, fieldsMap, tempFormData,fieldsValueMap);
                if (arr[0] != null && arr[1] != null && arr[0] === arr[1]) {
                    return true;
                }
            }
            return false;
        },
        async dealArr (currentField, arr, formData, fieldsMap, tempFormData,fieldsValueMap) {

            for (var i = 0; i < arr.length; i++) {
                let tempKey = arr[i];
                let field = fieldsMap.get(tempKey);
                if ((tempKey.indexOf(';') !== -1) || (tempKey.indexOf(',') !== -1)) {
                    let param = {};
                    param.valuesNode = formData;
                    param.formulaExp = tempKey;
                    let res = await getCrossFieldData(param);
                    if (res && res.finalVal) {
                        arr[i] = Number(res.finalVal);
                    } else {
                        arr[i] = null;
                    }
                }if((tempKey.indexOf('+') !== -1) || (tempKey.indexOf('-') !== -1) || (tempKey.indexOf('*') !== -1) || (tempKey.indexOf('/') !== -1)){
                    for (let [key, value] of fieldsValueMap) {
                        if(tempKey.indexOf(key) !== -1){
                            if(value){
                                tempKey=tempKey.replace(key,value);
                            }else{
                                this.$message.info('计算公式中存在无效值，请检查填写正确后保存');
                                return;
                            }
                        }
                    }
                    arr[i]=eval(tempKey);
                } else {
                    if (field && field.options.formulaExp) {
                        if (tempFormData) {
                            let formulaExp = field.options.formulaExp;
                            if ((formulaExp.indexOf(';') !== -1) || (formulaExp.indexOf(',') !== -1)) {
                                let param = {};
                                param.valuesNode = formData;
                                param.formulaExp = formulaExp;
                                param.tempFormData = tempFormData;
                                let res = await getCrossFieldData(param);
                                if (res && res.finalVal) {
                                    arr[i] = Number(res.finalVal);
                                    formData[field.id] = arr[i];
                                    // formData[field.id] = formData[field.id] ? Number(formData[field.id]) + arr[i] : arr[i];
                                    // fieldsMap.set(i, {fieldId: field.id, value: arr[i]});
                                } else {
                                    arr[i] = null;
                                }
                            } else {
                                arr[i] = formData[tempKey] ? Number(formData[tempKey]) : !Number.isNaN(tempKey) ? Number(tempKey) : null;
                            }
                        } else {
                            arr[i] = formData[tempKey] ? Number(formData[tempKey]) : !Number.isNaN(tempKey) ? Number(tempKey) : null;
                        }
                    } else {
                        arr[i] = formData[tempKey] ? Number(formData[tempKey]) : !Number.isNaN(tempKey) ? Number(tempKey) : null;
                    }
                }
            }
            return arr;
        }
    }
};
</script>

<style lang="less">
// .fieldValidationClass{
  
// }
</style>



// WEBPACK FOOTER //
// src/components/Formula/FieldValidation.vue